(function() {
	'use strict';
	angular.module('app.core')
		.directive('leanTimePeriodFilter', leanTimePeriodFilter);

	leanTimePeriodFilter.$inject = [];
	function leanTimePeriodFilter() {
		var html = '<div class="date-menu" ng-show="$parent.filterFunctions.getViewValues().visibleMenu == ' + "'" + '{{filterId}}' + "'" + '" ng-click="$event.stopPropagation();" >' +
						'<form name="dateForm" novalidate>' +
							'<div class="date-header">' +
								'<div class="date-title"><span translate> {{filterName}}</span></div>' +
							'</div>' +
							'<div class="date-body">' +
								'<div class="filter-dropdown form-group" ng-click="$event.stopPropagation();">' +
									'<select name="filterValue" ng-required="true" class="form-control" ng-model="filterValue" ng-options="timePeriod.value as timePeriod.timePeriodName for timePeriod in filterList" ng-disabled="readOnly">' +
									'</select>' +
									'<div class="input-group">' +
									'<input name="valueOne" ng-show="filterValue === ' + "'custom'" + '" type="text" class="form-control" ' +
										'uib-datepicker-popup="MMM yyyy" is-open="openedOne" datepicker-options="options" ' +
										'ng-required="true" show-button-bar="false" datepicker-mode="mode" ng-model="filterValueOne" ng-disabled="readOnly">' +
									'<span ng-show="filterValue === ' + "'custom'" + '" class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openOne()" ng-disabled="readOnly">' +
										'<i class="fa fa-calendar" style="line-height: 13px"></i></button></span>' +
									'</div>' +
									'<div class="input-group">' +
									'<input name="valueTwo" ng-show="filterValue === ' + "'custom'" + '" type="text" ' +
										'class="form-control" uib-datepicker-popup="MMM yyyy" show-button-bar="false" is-open="openedTwo" ' +
										'datepicker-options="options" minMode="month" ng-required="true" ng-model="filterValueTwo" ng-disabled="readOnly">' +
									'<span ng-show="filterValue === ' + "'custom'" + '" class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openTwo()" ng-disabled="readOnly">' +
										'<i class="fa fa-calendar" style="line-height: 13px"></i></button></span>' +
									'</div>' +
								'</div>' +
							'</div>' +
							'<div class="date-footer" ng-show="!readOnly">' +
								'<button class="button flat colored innerButton" ng-click="$parent.filterFunctions.cancelSelection()">' +
									'<span translate>Cancel</span>' +
								'</button>' +
								'<button class="button flat colored innerButton" data-testid="reportFilter-' + '{{filterId}}' + '-apply-btn" ng-disabled="$parent.filterFunctions.isReadOnly() || dateForm.filterValue.$invalid || (filterValue === ' + "'custom'" + ' && (dateForm.valueOne.$invalid || dateForm.valueTwo.$invalid))" ng-click="$parent.filterFunctions.applySelection($event, filterId)">' +
									'<span translate>Apply</span>' +
								'</button>' +
							'</div>' +
						'</form>' +
					'</div>';
		return {
			restrict:'EA',
			template: html,
			replace:true,
			transclude: true,
			scope: {filterName: '@',
											filterValue: '=',
											filterValueOne: '=',
											filterValueTwo: '=',
											filterList: '=',
											filterComparator: '=',
											filterLabel: '@',
											filterId: '@'},
			link: function(scope, element, attrs) {
				scope.readOnly = scope.$parent.filterFunctions.isReadOnly();
				scope.options = {
					datepickerMode : 'month',
					minMode: 'month'
				};
				scope.mode = 'month';
				scope.openOne = function() {
					scope.openedOne = true;
				};
				scope.openTwo = function() {
					scope.openedTwo = true;
				};
				scope.filterValueOne = new Date(scope.filterValueOne);
				scope.filterValueTwo = new Date(scope.filterValueTwo);
				if (!scope.filterValue || scope.filterValue === '') {
					scope.filterValue = 'all';
				}
			}
		};
	}
})();
